<template>
  <PodcastPaywall :podcast="context">
    <template #active>
      <SingleColumn>
        <template #header>
          <h1 class="text-3xl font-bold text-white">
            Tipps von der Kompass-KI
          </h1>
        </template>
        <template #content>
          <section v-if="empty" class="section">
            <div class="px-4 py-5 sm:px-6">
              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                Starte deine Wachstumsreise im St. Audio Studio, indem du deine Ziele definierst und Methoden ausprobierst, die darauf hinwirken.
              </p>
              <p class="mt-1 max-w-2xl text-sm text-gray-500">
                Ich melde mich regelmäßig mit neuen Empfehlungen bei dir!
              </p>
            </div>
          </section>
          <section v-else="empty" class="section">
            <ul role="list" class="divide-y divide-gray-200">
              <li v-for="assistance in results" :key="assistance.id" class="message">
                <div class="flex justify-between space-x-3">
                  <div class="min-w-0 flex-1">
                    <router-link :to="{name: 'assistances.show', params: {id: assistance.id}}" class="block focus:outline-none">
                      <span class="absolute inset-0" aria-hidden="true" />
                      <div class="flex flex-row items-center">
                        <EnvelopeIcon class="w-6 h-6 flex-shrink-0 text-gray-400 mr-4" />
                        <p class="truncate text-sm font-medium text-gray-900">
                          {{ assistance.subject }}
                        </p>
                      </div>
                    </router-link>
                  </div>
                  <time :datetime="assistance.created_at" class="timestamp">
                    {{ $d(new Date(assistance.created_at), 'short') }}
                  </time>
                </div>
              </li>
            </ul>
          </section>
        </template>
      </SingleColumn>
    </template>
    <template #inactive>
      <SingleColumn>
        <template #header>
          <section class="sm:flex sm:items-center sm:justify-between">
            <div class="sm:flex sm:space-x-5">
              <h1 class="text-3xl font-bold text-white">
                Die Kompass-KI ist Teil vom Studio Pro
              </h1>
            </div>
          </section>
        </template>
        <template #content>
          <ConversionTrigger :podcast="context" />
        </template>
      </SingleColumn>
    </template>
  </PodcastPaywall>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useFetchResources } from '@/client/actions';

const store = useStore();
const context = computed(() => store.getters['context/context']);
const parent = computed(() => store.getters['context/context'].id ?? null);
const target = computed(() => '/api/podcasts/' + parent.value + '/assistances');
const action = useFetchResources(target);

const { results, fetch, empty } = action;

const watcher = watch(target, fetch);
const mounted = onMounted(() => fetch());
</script>

<style scoped>
.section
{
  @apply bg-white shadow;
  @apply overflow-hidden;
  @apply sm:rounded-lg;
};

.message
{
  @apply relative py-5 px-4;
  @apply bg-white hover:bg-gray-50;
  @apply focus-within:ring-2;
  @apply focus-within:ring-inset;
  @apply focus-within:ring-teal-600;
};

.timestamp
{
  @apply flex-shrink-0;
  @apply whitespace-nowrap;
  @apply text-sm text-gray-500;
};
</style>
